export const RULE_TYPES = {
  RETURN_FEES: 'return_fees',
  RETURN_FEES_POLICY: 'fees_policy',
  RETURN_ELIGIBILITY: 'return_eligibility',
  RETURN_METHODS: 'return_methods',
  RETURN_REASONS: 'return_reasons',
  RETURN_REFUND_OPTIONS: 'return_refund_options',
  RETURN_DESTINATION_POLICY: 'destinations_policy',
  RETURN_METHODS_POLICY: 'return_methods_policy',
};

// hub-backend advertises aggregators for fees and methods too, but their UI is not part
// of IR-160 — add a rule type here to expose the any/all selector for it.
export const AGGREGATOR_RULE_TYPES = [RULE_TYPES.RETURN_REFUND_OPTIONS];

// hub-backend falls back to `any` when a criterion carries no aggregator.
export const DEFAULT_AGGREGATOR = 'any';

// A rule carrying one of these attributes is generated through hub-backend's vendor branch
// (RuleHandler.existVendorCriteria), which accumulates matching items and so always means
// "any item" — it never reads the aggregator. `product_vendor` is deliberately absent:
// existVendorCriteria matches these two attributes only, so those rules honour the aggregator.
export const VENDOR_ATTRIBUTES = ['product_vendor_name', 'product_vendor_type'];

export const MODES = {
  FEES: 'feesMode',
  DESTINATIONS: 'destinationsMode',
  RETURN_METHODS: 'returnMethodsMode',
  DESTINATION_SERVICE: 'destination-service',
  RETURN_METHODS_SERVICE: 'return-methods-service',
  FEES_SERVICE: 'fees-service',
};

export const MODE_KEYS = {
  FEES: 'fees_mode',
  RETURN_METHODS: 'return_methods_mode',
  DESTINATION: 'destination_mode',
  RETURNS_INTELLIGENCE: 'iris',
};

export const MODE_IDENTIFIERS = {
  DESTINATION: 'destination',
  RETURN_METHODS: 'returnMethods',
  FEES: 'fees',
  RETURNS_INTELLIGENCE: 'returnsIntelligence',
};

export const CATEGORIES = {
  RETURN_METHOD: 'return_method',
  RETURN_DC: 'return_dc',
  RETURN_FEES: 'return_fees',
  RETURN_ELIGIBILITY_MESSAGE: 'return_eligibility_message',
  PRODUCT_ELIGIBILITY: 'product_eligibility',
  RETURN_METHODS_WITH_CARRIER: 'return_methods_with_carrier',
};

export const FORM_TYPES = {
  DEFAULT: 'default',
  MULTI_PICKLIST: 'multi_picklist',
  BOOLEAN: 'boolean',
  DATE: 'date',
  TEXT: 'text',
  DAYS: 'days',
  NUMERIC: 'numeric',
  KEY_VALUE_TEXT: 'key_value_text',
  LIST_KEY_VALUE_TEXT: 'list_key_value_text',
  STATIC_VALUE: 'static_value',
  SUB_ITEMS: 'sub_items',
  CODE: 'code',
};
